/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ConceptDataType from './concept-data-type';
import ConceptDataTypeDetail from './concept-data-type-detail';
import ConceptDataTypeUpdate from './concept-data-type-update';
import ConceptDataTypeDeleteDialog from './concept-data-type-delete-dialog';

const ConceptDataTypeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ConceptDataType />} />
    <Route path="new" element={<ConceptDataTypeUpdate />} />
    <Route path=":id">
      <Route index element={<ConceptDataTypeDetail />} />
      <Route path="edit" element={<ConceptDataTypeUpdate />} />
      <Route path="delete" element={<ConceptDataTypeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ConceptDataTypeRoutes;
